<template>
  <div class="uni-max row m-0 calpage-d">
    <div class="col-lg-6 cd-padding">
      <div class="cal-results">
        <div class="p-4 uni-max-xs">
          <div class="cal-title">Debt Service Ratio</div>
          <div class="cal-table">
            <table>
              <thead>
                <tr>
                  <th class="first">Bank DSR</th>
                  <th>Repayment Ability / Month (RM)</th>
                  <th>Estimated Loan Amount (RM)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="first">65%</td>
                  <td>{{addComma(sDSR65)}}</td>
                  <td>{{addComma(sLA65)}}</td>
                </tr>
                <tr>
                  <td class="first">75%</td>
                  <td>{{addComma(sDSR75)}}</td>
                  <td>{{addComma(sLA75)}}</td>
                </tr>
                <tr>
                  <td class="first">85%</td>
                  <td>{{addComma(sDSR85)}}</td>
                  <td>{{addComma(sLA85)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="border-t p-4 uni-max-xs">
          <div class="cal-title">Breakdown</div>
          <div class="row m-0">
            <div class="pl-0 col-7">
              <div class="mb-3">Total Expenses</div>
              <div>Net Income</div>
            </div>
            <div class="pr-0 col-5">
              <div class="font-weight-bold mb-3">RM {{addComma(stotalExp)}}</div>
              <div class="font-weight-bold">RM {{addComma(snetIncome)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6 cd-padding">
      <div class="cal-form-container">
        <div class="cal-label">Monthly Nett Salary Income (RM / Month)</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="grossIncome" class="filter-price-range">
        </div>
        <div class="mt-2"><small>After EPF, Soscso, TAX and etc</small></div>

        <div class="about-title mt-5">Monthly Commitment</div>

        <div class="cal-label">Car Installment</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="carInst" class="filter-price-range">
        </div>

        <div class="cal-label">Credit Card</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="credCard" class="filter-price-range">
        </div>

        <div class="cal-label">Personal Loan</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="persLoan" class="filter-price-range">
        </div>

        <div class="cal-label">Others (If any)</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="loanchecker_otherS" class="filter-price-range">
        </div>

        <button @click="calculate" class="cal-btn">
          <span v-if="isloaded">Check my Loan Eligibility</span>
          <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
            <span class="sr-only">Loading...</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LoanChecker',
    data: function () {
      return {
        // Loan Checker
        grossIncome: null,
        carInst: null,
        credCard: null,
        persLoan: null,
        loanchecker_otherS: null,
        isloaded: true,

        // Results (update when press calculate)
        stotalExp: '',
        snetIncome: '',
        sDSR65: '',
        sDSR75: '',
        sDSR85: '',
        sLA65: '',
        sLA75: '',
        sLA85: '',
      }
    },
    mounted() {
      this.grossIncome = 3000;
      this.carInst = 0;
      this.credCard = 0;
      this.persLoan = 0;
      this.loanchecker_otherS = 0;

      this.stotalExp = this.totalExp;
      this.snetIncome = this.netIncome;
      this.sDSR65 = this.DSR65;
      this.sDSR75 = this.DSR75;
      this.sDSR85 = this.DSR85;
      this.sLA65 = this.LA65;
      this.sLA75 = this.LA75;
      this.sLA85 = this.LA85;
    },
    computed: {
      totalExp() {
        return parseFloat(this.loanchecker_otherS) + parseFloat(this.credCard) + parseFloat(this.persLoan) + parseFloat(this.carInst);
      },
      netIncome() {
        return parseFloat(this.grossIncome) - parseFloat(this.totalExp);
      },
      DSR65() { return Math.round(this.netIncome * 0.65) },
      DSR75() { return Math.round(this.netIncome * 0.75) },
      DSR85() { return Math.round(this.netIncome * 0.85) },
      LA65() { return this.DSR65 * 200 },
      LA75() { return this.DSR75 * 200 },
      LA85() { return this.DSR85 * 200 },
    },
    methods: {
      addComma: function (num) {
        if (num != null) {
          var num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return '';
        }
      },
      isEven: function (n) {
        var num = n;
        if (Math.floor(n) % 2 == 0) { // is even with decimal
          num = Math.round(n)
          if (num % 2 != 0) {
            num = num + 1
          }
        } else { // is odd with decimal
          num = Math.floor(n) + 1;
        }
        return num;
      },
      calculate: function() {
        this.isloaded = false;

        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.isloaded = true;

          // Update Results
          this.stotalExp = this.totalExp;
          this.snetIncome = this.netIncome;
          this.sDSR65 = this.DSR65;
          this.sDSR75 = this.DSR75;
          this.sDSR85 = this.DSR85;
          this.sLA65 = this.LA65;
          this.sLA75 = this.LA75;
          this.sLA85 = this.LA85;
        }, 500);
      }
    },
  }
</script>